import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";

interface ICustomKeywordsSelectProps {
  selectedKeywords: string[];
  setSelectedKeywords: (keywords: string[]) => void;
}

export const CustomKeywordsSelect = ({
  selectedKeywords,
  setSelectedKeywords,
}: ICustomKeywordsSelectProps) => {
  const [newKeyword, setNewKeyword] = useState<string>("");
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`internaltoolsPage.checkOwnerArea.${key}`);

  const handleAddKeyword = () => {
    const _keyword = newKeyword.trim();
    if (_keyword === "" || selectedKeywords.includes(_keyword)) {
      setNewKeyword("");
      return;
    }
    setSelectedKeywords([...selectedKeywords, _keyword]);
    setNewKeyword("");
  };

  const handleRemoveKeyword = (keyword: string) => {
    setSelectedKeywords(selectedKeywords.filter((k) => k !== keyword));
  };

  return (
    <div className="custom-keywords-select">
      <h3>{t("custom_keywords_title")}</h3>
      {selectedKeywords.map((keyword) => (
        <div className="custom-keyword-item" key={keyword}>
          <button
            className="btn btn-border btn-border-red"
            onClick={() => handleRemoveKeyword(keyword)}
          >
            {t("remove")}
          </button>
          <span>{keyword}</span>
        </div>
      ))}
      <div className="custom-keyword-input">
        <input
          type="text"
          value={newKeyword}
          onChange={(e) => setNewKeyword(e.target.value)}
        />
        <button className="btn btn-border" onClick={handleAddKeyword}>
          {t("add")}
        </button>
      </div>
    </div>
  );
};
